import { ChildRecipeEntity } from '@core/redux/stores';

export enum Sources {
  REWARD = 'rewards',
  MENU = 'menu',
  FAVORITE = 'favorite',
  ORDER = 'order',
  OFFER = 'offer',
  LINKED = "linked"
}

export interface ChildChanged {
  childRecipe: ChildRecipeEntity;
  from: any;
}

export enum AssociatedItemType {
  side = 1,
  drink = 2
}

export class CustomizationObj {
  source: string;
  buttonText: string;
  routerLink: string;
}
export enum RecipeType {
  AlaCarte = 1,
  MediumMeal = 2,
  SmallMeal = 3,
  Breakfast = 4,
  KidsMeal = 5,
  Bundle = 6
}

export interface RecipeMap {
  recipeType: number
  linkedRecipeId?: number
  recipeId: number
}
